
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecoflow-botschafter-programm",
      function () {
        return require("private-next-pages/ecoflow-botschafter-programm/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecoflow-botschafter-programm"])
      });
    }
  